import { cx } from '@linaria/core';
import { useRef, useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { CSSRefTransition, Chevron } from '@utils/react';
import { useOnboarding } from './_onboarding.hook.js';
import { panelTransitionDurationMs, wrapperCls, screenTransitionDurationMs, screenCls, animationCls, iframeCls, screenTitleCls, screenBodyCls, bulletsCls, buttonsWrapperCls, buttonCls, beginButtonCls } from './_onboarding.style.js';
import { Bullets } from './bullets.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Onboarding(props) {
  const [currentScreen, state, callbacks] = useOnboarding(props.onCompleted);
  const prevIndex = useRef(state.currentIndex);
  useEffect(() => {
    prevIndex.current = state.currentIndex;
  }, [state.currentIndex]);
  const direction = state.currentIndex > prevIndex.current ? "forwards" : "backwards";
  return /*#__PURE__*/jsx(CSSRefTransition, {
    in: props.active,
    timeout: panelTransitionDurationMs,
    classNames: wrapperCls,
    mountOnEnter: true,
    unmountOnExit: true,
    children: ref => /*#__PURE__*/jsxs("section", {
      ref: ref,
      className: cx(wrapperCls, direction),
      children: [/*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: /*#__PURE__*/jsx(CSSRefTransition, {
          timeout: screenTransitionDurationMs,
          classNames: screenCls,
          children: ref => /*#__PURE__*/jsxs("div", {
            ref: ref,
            className: screenCls,
            children: [/*#__PURE__*/jsx("div", {
              className: animationCls,
              children: /*#__PURE__*/jsx("iframe", {
                className: cx(iframeCls, !state.isTransitioning && "ready"),
                "aria-hidden": true,
                sandbox: "allow-scripts",
                src: !state.isTransitioning ? currentScreen?.animation.src : "about:blank",
                width: currentScreen?.animation.width,
                height: currentScreen?.animation.height,
                frameBorder: 0,
                tabIndex: -1
              })
            }), /*#__PURE__*/jsx("h1", {
              className: screenTitleCls,
              children: currentScreen?.title
            }), /*#__PURE__*/jsx("p", {
              className: screenBodyCls,
              children: currentScreen?.body
            })]
          })
        }, currentScreen?.title)
      }), /*#__PURE__*/jsx(Bullets, {
        className: bulletsCls,
        current: state.currentIndex,
        amount: state.totalScreens
      }), /*#__PURE__*/jsxs("div", {
        className: buttonsWrapperCls,
        children: [/*#__PURE__*/jsxs("button", {
          className: cx(buttonCls, !state.canGoBack && "hidden"),
          onClick: callbacks.prev,
          disabled: !state.canGoBack,
          children: [/*#__PURE__*/jsx(Chevron, {
            className: "chevron",
            inversed: true,
            size: 10
          }), /*#__PURE__*/jsx("span", {
            children: "Forrige"
          })]
        }), /*#__PURE__*/jsx("button", {
          className: cx(buttonCls, "dimmed"),
          onClick: callbacks.skip,
          children: "Spring over"
        }), /*#__PURE__*/jsxs("button", {
          className: cx(buttonCls, !state.canGoForwards && "hidden"),
          onClick: callbacks.next,
          disabled: !state.canGoForwards,
          children: [/*#__PURE__*/jsx("span", {
            children: "N\xE6ste"
          }), /*#__PURE__*/jsx(Chevron, {
            className: "chevron",
            size: 10
          })]
        }), /*#__PURE__*/jsxs("button", {
          className: cx(buttonCls, beginButtonCls, state.canGoForwards && "hidden"),
          onClick: callbacks.skip,
          disabled: state.canGoForwards,
          children: [/*#__PURE__*/jsx("span", {
            children: "Start"
          }), /*#__PURE__*/jsx(Chevron, {
            className: "chevron",
            size: 10
          })]
        })]
      })]
    })
  });
}

export { Onboarding };
//# sourceMappingURL=_onboarding.js.map
